'use client';

import { useEffect, useState } from 'react';

export type ProductType = {
  productType: string;
  colorCount: number;
};

export function useTypes() {
  const [types, setTypes] = useState<ProductType[]>([]);

  useEffect(() => {
    fetch('/api/products/types')
      .then((res) => res.json())
      .then(({ types }) => setTypes(types));
  }, []);

  return types;
}
